import store from '@/store'
import { app } from '@/main.js'


export default (to, from, next) => {

  if (app.helpers.getTokenParam()){
    store.commit('auth/setToken', app.helpers.getTokenParam());
  }

  if (!store.state.auth.authenticated) {
      store.dispatch('auth/logout', { logoutAuth: false });
      return;
  }

  return next()

  // if(store.state.auth.authenticated === null || store.state.auth.authenticated == undefined)
  //   window.location.href = process.env.VUE_APP_AUTH_BASE_URL + `/login/?redirect_url=` + encodeURIComponent(process.env.VUE_APP_BASE_URL + `/validation`) + `&logout=true`

  // else
  //   return next()
}
